import Axios from '@/assets/js/AxiosPlugin'

// 验证统计
export const couponStatistics = params => { return Axios.post('/api/Admin/Statistics/coupon', params) }

// 会员使用优惠劵记录
export const searchCouponList = params => { return Axios.post('/api/Admin/Member/searchCouponList', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CouponListApp/apis/index.js